import http from 'plugins/axios';

export default {
  calculateTeamAmount(data) {
    return http.post({
      url: '/la/admin/shareholder/team/amount/calculate',
      data,
      dataType: 'form'
    });
  },
  shareholderCheck(data) {
    return http.post({
      url: '/la/admin/shareholder/level/check',
      data,
      dataType: 'form'
    });
  },
  listShareholders(data) {
    return http.get({
      url: '/la/admin/shareholder/list',
      data
    });
  },
  updateProfit(data) {
    return http.post({
      url: '/la/admin/dividend/profit/update',
      data,
      dataType: 'form'
    });
  },
  getProfit() {
    return http.get({
      url: '/la/admin/dividend/profit'
    });
  },
  getTaskDetail(id) {
    return http.get({
      url: '/la/admin/dividend/task/detail',
      data: {
        id
      }
    });
  },
  billTask(data) {
    return http.post({
      url: '/la/admin/dividend/record/execute',
      data,
      dataType: 'form'
    });
  }
};
